import React, {useCallback} from "react";
import "./AchSwitcher.scss";
import {Button} from "../../../ui-components/Button/Button";

export enum PAYMENT_METHOD_TYPE {
    CREDIT_CARD,
    ACH
}

interface AchSwitcherProps {
    currentType: PAYMENT_METHOD_TYPE;
    onSetPaymentMethodType: (paymentMethod: PAYMENT_METHOD_TYPE) => void;
}

export const AchSwitcher: React.FunctionComponent<AchSwitcherProps> = (props) => {
    const setCreditCardMethod = () => {
        props.onSetPaymentMethodType(PAYMENT_METHOD_TYPE.CREDIT_CARD);
    }

    const setAchMethod = () => {
        props.onSetPaymentMethodType(PAYMENT_METHOD_TYPE.ACH);
    }

    const isCreditCardPaymentMethod = useCallback(() => {
        return props.currentType === PAYMENT_METHOD_TYPE.CREDIT_CARD;
    }, [props.currentType]);

    const isAshPaymentMethod = useCallback(() => {
        return props.currentType === PAYMENT_METHOD_TYPE.ACH;
    }, [props.currentType]);

    return <div className="ach-switcher-container">
        <Button className={isCreditCardPaymentMethod() ? 'active-button' : 'secondary-button'} onClick={setCreditCardMethod} type={'button'}>Credit
            Card</Button>
        <Button className={isAshPaymentMethod() ? 'active-button' : 'secondary-button'} onClick={setAchMethod}>ACH</Button>
    </div>
}
